import type { HttpClient } from 'services/api-client/client';
import { returnData } from 'services/api-client/client';
import type { BillingApi } from '@env0/billing-service/api';

export default (client: HttpClient) => ({
  getBillingInformation: (organizationId: string) =>
    client.get<BillingApi.GetBillingInformation.Response>(`billing/organizations/${organizationId}`).then(returnData),
  getUsage: (organizationId: string, params?: { history: 'daily' }) =>
    client
      .get<BillingApi.GetUsage.Response>(`billing/organizations/${organizationId}/usage`, { params })
      .then(returnData),
  getInvoices: (organizationId: string) =>
    client.get<BillingApi.GetInvoices.Response>(`billing/organizations/${organizationId}/invoices`).then(returnData),
  getManageSubscriptionLink: (organizationId: string) =>
    client
      .get<BillingApi.GetManageSubscriptionLink.Response>(
        `billing/organizations/${organizationId}/manage-subscription-link`
      )
      .then(returnData)
});
